// extracted by mini-css-extract-plugin
module.exports = {"Card":"ListProduct_Card__2uY9K","Sidebar":"ListProduct_Sidebar__27aI8"};